module.exports = __webpack_public_path__ + "img/LaBase-Suppli-Alla-Romana-600px.6b83de62.jpg";